<template>
  <div>
    <div class="cms-header-content-null"></div>
    <div class="cms-header-content left">
      <div class="cms-container">
        <div class="logo-image left">
          <img :src="logoUrl" class="w-100 h-100" alt="">
        </div>
        <ul class="menu_ul right clearfix menu_ul_new">
          <li class="right categoryItem">
            <router-link
                :class="{'one_a':true,'qy-head-active':true}"
                :to="{path:'/specializedZoneYx','query':{'companyId':headCompanyId,'id':company.companyId,'headLogo':headLogo}}">
              首页
            </router-link>
          </li>
          <li class="right categoryItem">
            <router-link class="one_a" v-if="company.companyId != '2706'"
                         :to="{name:'zonePurchase','query':{'companyId':headCompanyId,'id':company.companyId,'headLogo':headLogo}}">
              招标采购
            </router-link>
          </li>
          <li class="right categoryItem" @click="toLink(1)" v-if="company.companyId =='6802'">
            <span :class="{'one_a':true}">公司官网</span>
          </li>
          <li class="right categoryItem" @click="toLink(2)" v-if="company.companyId =='6802'">
            <span :class="{'one_a':true}">政策法规</span>
          </li>
          <li class="right categoryItem">
            <router-link class="one_a" to="/help">帮助中心</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="cms-container">
      <div class="row1 left">
        <div class="home-carousel left company-carousel">
          <zone-carousel :carousels="carousels" class="cms-sm-hidden cms-ssm-hidden"></zone-carousel>
          <el-carousel class="cms-lg-hidden cms-xl-hidden cms-md-hidden" id="app-carousel" :height="bannerHeight+'px'">
            <el-carousel-item v-for="(items,index) in carousels" :key="'items-'+index" interval="3000">
              <el-row>
                <el-col v-for="(item ,i) in items.bgUrl" :key="'item'+i" class="curse">
                  <img ref="bannerHeight" class="w-100 carousel-img" :src="item.url" alt="" @load="imgLoad">
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="home-left left">
          <yx-link :company="company"></yx-link>
        </div>
      </div>
      <div class="zone-content">
        <purchase-info :company="company"></purchase-info>
        <div style="margin-bottom: 10px" class="zone-card">
          <zone-card title="永信案例" style="margin-bottom: 20px"></zone-card>
          <img class="w-100" src="../../assets/image/pc/yxal.png" alt="">
          <div class="classify-button classify-button-collective">
            <el-divider content-position="center">
              <div @click="toLink(3)" class="classify-more" @mouseover="changeIndex(0,'caseMoreList')"
                   @mouseout="changeIndexBack(0,'caseMoreList')" v-for="(item,inedx) in caseMoreList"
                   :key="inedx+'scas'">
                <img class="w-100" v-show="!item.show" :src="require('../../assets/image/pc/'+item.unchecked+'.png')"
                     alt="">
                <img class="w-100" v-show="item.show" :src="require('../../assets/image/pc/'+item.active+'.png')"
                     alt="">
              </div>
            </el-divider>
          </div>
        </div>
        <div style="margin-bottom: 10px" class="zone-card">
          <zone-card title="永信客户" style="margin-bottom: 20px"></zone-card>
          <img class="w-100" src="../../assets/image/pc/yxkh.png" alt="">
          <div class="classify-button classify-button-collective">
            <el-divider content-position="center">
              <div @click="toLink(4)" class="classify-more" @mouseover="changeIndex(0,'clientMoreList')"
                   @mouseout="changeIndexBack(0,'clientMoreList')" v-for="(item,inedx) in clientMoreList"
                   :key="inedx+'scas'">
                <img class="w-100" v-show="!item.show" :src="require('../../assets/image/pc/'+item.unchecked+'.png')"
                     alt="">
                <img class="w-100" v-show="item.show" :src="require('../../assets/image/pc/'+item.active+'.png')"
                     alt="">
              </div>
            </el-divider>
          </div>
        </div>
        <div class="zone-card" style="margin-bottom: 30px">
          <zone-card title="联系我们" style="margin-bottom: 20px"></zone-card>
          <img class="w-100" src="../../assets/image/pc/yxlxwm.png" alt="">
        </div>
      </div>
    </div>
    <zone-footer-two :company="company"></zone-footer-two>
  </div>
</template>

<script>
import zoneCarousel from "../zone/zone-carousel";
import axios from "axios";
import YxLink from "@/views/specialized-zone-yx/yx-link";
import PurchaseInfo from "@/views/specialized-new-zone-two/purchase-info";
import ZoneFooterTwo from "@/views/specialized-new-zone-two/zone-footer-two";
import ZoneCard from "@/views/specialized-new-zone-two/zone-card";

export default {
  name: "specialized-zone-yx",
  components: {
    ZoneCard,
    ZoneFooterTwo,
    PurchaseInfo,
    YxLink,
    zoneCarousel,
  },
  created() {
    this.headCompanyId = this.$route.query.companyId;
    this.headId = this.$route.query.id;
    this.headLogo = this.$route.query.headLogo;
    this.id = this.$route.query.id;
    if (this.companyId == null || this.companyId == "") {
      this.isCompany = false;
    }
    //初始化公司信息
    this.getCompany(this.$route.query.companyId, "company");
    /*初始化轮播图*/
    this.selectPromotionList("zone_carousel", "carousel", "carouselList");
    this.getCategory(this.headCompanyId);
    /*初始化卡片*/
    this.getConfigs(203);

  },
  mounted() {

    let mobile = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );

    if (mobile != null) {
      this.isMobile = true
      console.log(this.isMobile)
    } else {
      this.isMobile = false
      console.log(this.isMobile)
    }

    this.setHeadHeight();
    window.addEventListener('resize', () => {
      // this.bannerHeight = this.$refs.bannerHeight[0].height;
      this.setHeadHeight();
      this.imgLoad();
    }, false)
  },
  data() {
    return {
      entityBuyer: {},
      companyId: "",
      id: "",
      headCompanyId: "",
      headLogo: "",
      headId: "",
      carouselList: [],
      logoUrl: "",
      linkUrl: "",
      contactText: "",
      company: {},
      promotion: "",
      isBid: false,
      activeClass: 0,
      carousels: [],
      queryType: "all",
      bannerHeight: "",
      configForm: {},
      isMobile: false,
      caseMoreList: [
        {
          unchecked: 'collective-view-more',
          active: 'collective-view-more-active',
          show: false
        }
      ],
      clientMoreList: [
        {
          unchecked: 'collective-view-more',
          active: 'collective-view-more-active',
          show: false
        }
      ],
    };
  },
  methods: {
    changeIndex(e, entryName) {
      this[entryName][e].show = !this[entryName][e].show;
    },
    changeIndexBack(e, entryName) {
      this[entryName][e].show = !this[entryName][e].show;
    },
    headActive: function (name) {
      return name == this.$route.name;
    },
    toLink(type) {
      if (1 === type) {
        window.open('http://www.yongxinepm.com/');
      }
      if (2 === type) {
        window.open('http://www.yongxinepm.com/category/%e6%8b%9b%e6%a0%87%e4%bf%a1%e6%81%af/%e6%94%bf%e7%ad%96%e6%b3%95%e8%a7%84');
      }
      if (3 === type) {
        window.open('http://www.yongxinepm.com/%e4%b8%9a%e5%8a%a1%e6%9d%bf%e5%9d%97');
      }
      if (4 === type) {
        window.open('http://www.yongxinepm.com/%e4%b8%bb%e8%a6%81%e5%ae%a2%e6%88%b7');
      }
    },
    getConfigs: function (id) {
      var that = this;
      this.$http.get(this.base + "/content/getCall.do", {
        params: {
          id: id
        }
      }).then(function (res) {
        var data = res.data.result;
        if (data) {
          that.configForm = data;
          var userNames = that.configForm.userName.split("/");
          var phones = that.configForm.phone.split("/");
          that.configForm['userNames'] = userNames;
          that.configForm['phones'] = phones;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height;
      })
    },
    selectPromotionList: function (modelId, entityName, entityListName) {
      var that = this;
      axios.get(this.base + "/category/get.do", {
        params: {
          modelId: modelId
        }
      }).then((data) => {
        that[entityName] = data.data.result;
        var categoryId = data.data.result.id;
        axios.get(that.base + "/promotion/list.do", {
          params: {
            categoryId: categoryId
          }
        }).then((data) => {
          that.zhuanquSize = data.data.result.length;
          for (var i = 0; i < data.data.result.length; i++) {
            if (data.data.result[i].imagesUrl != null && data.data.result[i].imagesUrl != "") {
              data.data.result[i].imagesUrl = JSON.parse(data.data.result[i].imagesUrl);
            }
            if (data.data.result[i].companyId == this.headId) {
              data.data.result[i].bgUrl = JSON.parse(data.data.result[i].bgUrl);
              that.carousels.push(data.data.result[i]);
            }
          }
          if (this.headId == "") {
            let ca = {
              "id": "",
              "title": "",
              "imagesUrl": [{
                "path": "",
                "url": "https://old2.holdcg.com/group1/M00/02/E8/CgA7PmJWPgaAZPa3AAdhuxyoXvE150.png",
                "uid": "",
                "size": "66.15",
                "status": "success"
              }],
              "categoryId": "",
              "url": "",
              "linkText": "",
              "createdTime": "",
              "updateTime": null,
              "userId": "0",
              "companyId": "",
              "companyName": null,
              "isDeleted": 0,
              "isIssue": 0,
              "sortNo": 0,
              "groupId": null,
              "intervalId": null,
              "keyword": "",
              "description": "",
              "registeredCapital": "",
              "industry": "",
              "businessScope": "",
              "logoUrl": "\"\"",
              "bgUrl": [{
                "path": "",
                "url": "https://old2.holdcg.com/group1/M00/02/E8/CgA7PmJWPgaAZPa3AAdhuxyoXvE150.png",
                "uid": "",
                "size": "66.15",
                "status": "success"
              }],
              "contactText": "",
              "isRecommend": 0,
              "linkUrl": ""
            };
            that.carousels.push(ca);
          }

          that[entityListName] = data.data.result;
        })
      })
    },
    getParameter: function (paraName) {
      var url = document.location.toString();
      if (url.lastIndexOf('#') == (url.length - 1)) {
        url = url.substring(0, url.lastIndexOf('#'));
      }
      var arrObj = url.split("?");

      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
    getCategory: function (id) {
      var that = this;
      let cId = id + "";
      if (cId != null && cId != '' && cId.length > 0) {
        that.$http.get(this.base + "/promotion/get.do", {
          params: {
            'id': cId
          }
        }).then((data) => {
          let dataRes = data.data.result;
          that.logoUrl = JSON.parse(dataRes.logoUrl)[0].url;
          that.linkUrl = dataRes.linkUrl;
          that.contactText = dataRes.contactText;
        })
      }
    },
    getCompany: function (promotionId, entityName) {
      var that = this;
      that.promotion = promotionId;
      that.$http.get(that.base + "/promotion/get.do", {
        params: {
          id: that.promotion
        }
      }).then((da) => {
        if (da.data.result.title.indexOf('涟源') != -1 || da.data.result.title.indexOf('涟钢') != -1 || da.data.result.title.indexOf('VAMA') != -1 || da.data.result.title.indexOf('安赛乐米塔尔') != -1) {
          that.isBid = true;
          that.activeClass = 1;
        }
        that[entityName] = da.data.result;
        that.$nextTick(() => {
          document.title = that.company.title;
        })
      });
    },
    getItem: function (index) {
      this.activeClass = index;
    },
    goShopping: function () {
      window.open("https://mall.holdcg.com");
    },
    setHeadHeight: function () {
      let head = document.getElementsByClassName("cms-header-content")[0].offsetHeight + 10;
      document.getElementsByClassName("cms-header-content-null")[0].style.height = head + "px";
    }
  }
}
</script>
<style scoped lang="css" src="../../assets/commoon/css/common.css"></style>
<style>


@media (min-width: 768px) and (max-width: 992px) {
  .company-carousel .carousel-img {
    background-position: unset !important;
  }
}

@media (min-width: 576px) and (max-width: 768px) {
  .company-carousel .el-carousel__container {
    height: 300px !important;
  }

  .company-carousel .carousel-img {
    object-fit: cover;
    object-position: left;
    height: 300px !important;
  }
}
</style>
<style lang="scss" scoped>

.zone-content {
  width: 1160px;
  margin: 0 auto;
  padding-top: 10px;
  background: white;
  overflow: auto;
}

.cms-header-content {
  position: fixed;
  z-index: 100;
  width: 100%;
  top: 0;
}

.home-head {
  background: #F4F4F4;
}

.menu_ul {
  border: none;
  margin-top: 10px;
  color: #6A6A6A;
  width: 600px;
  display: flex;
}

.categoryItem {
  flex: 1;
  text-align: center;
}

.cms-footer {
  width: 100%;
  height: 40px;
  background: #EFEFEF;
  display: flex;
  justify-content: center;
  color: #666666;
  font-size: 1.4rem;
  align-items: center;
}

.cms-header-content {
  background: #FFFFFF;
  width: 100%;
  height: 79px;
  margin: 0 auto;
  padding-top: 5px;
  margin-bottom: 20px;
}


.logo-image {
  width: 400px;
  height: 60px;
  margin: 2px 4px 1px 4px;
}

.menu_ul li {
  padding: 0px;
}

@media (min-width: 1200px) {
  .row1 {
    height: 300px;
    width: 1160px;
    margin-bottom: 20px;
  }
}

/*.row1 {
  height: 300px;
  width: 1160px;
  margin-top: 19px;
}*/

.home-carousel {
  width: 908px;
  height: 100%;
}

.home-left {
  width: 233px;
  height: 100%;
  margin-left: 19px;
}

.menu_ul li .one_a {
  color: #6A6A6A !important;
}

@media (min-width: 992px) and (max-width: 1200px) {
  .home-head {
    background: #F4F4F4;
  }

  .zone-content {
    width: 100%;
    padding: 0px 20px;
    background: white;
  }

  /*.categoryItem {
    padding-left: 28px !important;
    padding-right: 28px !important;
  }*/
  .menu_ul_new {
    width: 600px !important;
  }

  .cms-header-content {
    background: #FFFFFF;
    width: 100%;
    height: 83px;
    margin: 0 auto;
    padding-top: 10px;
    margin-bottom: 15px;
  }


  .logo-image {
    width: 334px;
    height: 63px;
    margin: 2px 4px 1px 4px;
  }

  .row1 {
    height: 251px;
    width: 960px;
    margin-bottom: 15px;
  }

  .home-carousel {
    width: 756px;
    height: 100%;
  }

  .home-left {
    width: 195px;
    margin-left: 9px;
  }


  .company-content p[data-v-71f6a296] {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 13;
    -webkit-box-orient: vertical;
  }
}

@media (min-width: 768px) and (max-width: 992px) {

  .menu_ul_new {
    width: 460px !important;
    margin-top: 0px !important;
  }
  .zone-content {
    width: 100%;
    padding: 10px 20px;
  }

  /*.categoryItem {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }*/
  .home-head {
    background: #F4F4F4;
  }


  .cms-header-content {
    background: #FFFFFF;
    width: 100%;
    height: 61px;
    margin: 0 auto;
    padding-top: 10px;
    margin-bottom: 10px;
  }


  .logo-image {
    width: 247px;
    height: 46px;
    margin: 2px 4px 1px 4px;
  }

  .row1 {
    height: 300px;
    width: 720px;
    margin-bottom: 10px;
    position: relative;
  }

  .home-carousel {
    width: 100%;
    height: 100%;
  }

  .home-left {
    width: 245px;
    height: 100%;
    margin-left: 7px;
    position: absolute;
    z-index: 10000000;
    right: 10px;
    /*background: white;*/
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
  }
}

@media (min-width: 576px) and (max-width: 768px) {
  .home-head {
    background: #F4F4F4;
  }
  .zone-content {
    width: 100%;
    padding: 10px 20px;
  }

  .cms-header-content {
    background: #FFFFFF;
    width: 100%;
    height: 110px;
    margin: 0 auto;
    /*padding-top: 10px;*/
  }

  .logo-image {
    width: 247px;
    height: 46px;
    margin: 2px 4px 1px 4px;
  }

  .row1 {
    /*height: 248px;*/
    width: 100%;
    margin-bottom: 10px;
    position: relative;
  }

  .home-carousel {
    width: 100%;
    height: 300px;
  }

  .home-left {
    width: 245px;
    height: 100%;
    margin-left: 7px;
    position: absolute;
    z-index: 10000000;
    right: 10px;
    /*background: white;*/
    padding: 10px 0px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
  }


  .categoryItem {
    text-align: center;
    flex: 1;
    padding: 0px !important;
  }

  .menu_ul {
    padding: 0px;
    margin: 0px;
  }
}

@media screen and (max-width: 576px) {
  .home-head {
    width: 100%;
  }

  .zone-content {
    width: 100%;
    padding: 0px 20px;
  }

  .logo-image {
    max-width: 100%;
  }

  .row1 {
    width: 100%;
  }

  .home-carousel {
    width: 100%;
    height: 100%;
  }

  .home-left {
    width: 100%;
    margin-left: 0px !important;
    padding: 10px;
  }

  .categoryItem {
    text-align: center;
    flex: 1;
    padding: 0px !important;
  }

  .menu_ul {
    padding: 0px;
    margin: 0px;
  }

  .cms-header-content {
    background: #FFFFFF;
    width: 100%;
    height: 120px;
    margin: 0 auto;
  }
}


.qy-head-active {
  font-weight: bold;
  border-bottom: 3px solid rgb(0, 104, 183) !important;
  color: rgb(0, 104, 183) !important;
}

.menu_ul li:hover .qy_one_a {
  color: rgb(0, 104, 183) !important;
  border-bottom: 3px solid rgb(0, 104, 183) !important;
}


.classify-button {
  width: 90%;
  margin: 0 auto;
  margin-top: 40px;
}

.classify-button-collective {
  margin-top: 20px;

}

.classify-more {
  width: 180px;
  cursor: pointer;
  margin: 0 auto;
  margin-top: 0px;
  background: white;
}

.el-divider {
  background: #5387F7;
}

.el-divider__text {
  padding: 0 8 s0px;
}

.menu_ul li:hover .one_a {
  cursor: pointer;
  font-weight: bold;
  color: #275adc !important;
  border-bottom: 3px solid #275adc !important;
}
</style>
